import React from "react";
import FormattedText from "../../../FormattedText/FormattedText";
import type { TextNodeType } from "../../../FormattedText/FormattedText";
import { Logo, Row, TextCol, Title } from "./Styles";

interface PlansHeaderProps {
  plansHeaderData?: {
    title?: string;
    subtitle?: TextNodeType;
    icon?: string;
  };
}

export const PlansHeader = ({ plansHeaderData }: PlansHeaderProps) => {
  if (!plansHeaderData?.title && !plansHeaderData?.subtitle && !plansHeaderData?.icon) {
    return null;
  }

  return (
    <Row>
      <TextCol>
        {plansHeaderData.title ? (
          <Title>{plansHeaderData.title}</Title>
        ) : null}
        {plansHeaderData.subtitle ? (
          <div style={{ fontSize: 12, color: "#757575" }}>
            <FormattedText value={plansHeaderData.subtitle} />
          </div>
        ) : null}
      </TextCol>
      {plansHeaderData.icon ? (
        <Logo src={plansHeaderData.icon} alt="" />
      ) : null}
    </Row>
  );
};
